// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 21:01:36

export default {
  "id": "ohpeach-it",
  "slug": "ohpeach-it",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/fcddb258fff94e4895bd18ce44136b66-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/fcddb258fff94e4895bd18ce44136b66/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "OhPeach-It",
      "description": "OhPeach-It is a game about dash&merge fruits that provides\nyou fun and engaging gameplay.\n\nGame becomes more engaging when you use the idle mechanism and use power-ups.\n\nSo keep the fruits dash and merge !",
      "instructions": "Held & Dash fruits with each other to make higer fruit. Make juice from fruits and score more.",
      "genres": [
        "Merge"
      ],
      "tags": [
        "aim",
        "fruits"
      ]
    },
    "zh-CN": {
      "title": "哦桃子-它",
      "description": "OhPeach-这是一款关于冲刺与合并水果的游戏，它为你带来有趣且吸引人的游戏体验。\n\n当你使用空闲机制和利用道具时，游戏变得更加吸引人。\n\n所以，保持水果冲刺与合并吧！",
      "instructions": "将水果相互举起并冲刺，制作出更高等级的水果。从水果中榨取果汁，获得更多分数。",
      "genres": [
        "合并"
      ],
      "tags": [
        "瞄准",
        "水果"
      ]
    },
    "zh-TW": {
      "title": "歡迎！- 愛桃子",
      "description": "OhPeach-是一款關於衝刺與合併水果的遊戲，提供你趣味與吸引人的遊戲體驗。\n\n當你使用閒置機制和使用強化道具時，遊戲會更加吸引人。\n\n所以繼續讓水果衝刺與合併吧！",
      "instructions": "將水果相互拿來碰觸，以製造更高級的水果。從水果中製作果汁，得分更高。",
      "genres": [
        "合併"
      ],
      "tags": [
        "標準射擊",
        "水果"
      ]
    },
    "zh-HK": {
      "title": "哦桃-它",
      "description": "OhPeach-是一款關於衝刺合併果物的遊戲，為您帶來歡樂和吸引人的遊戲體驗。\n\n當你使用閒置機制和使用加強功能時，遊戲的吸引力會更強。\n\n所以繼續讓果物衝刺合併吧！",
      "instructions": "攜手跳躍果物，製造更高級果物。由果物製成飲汁，得分更高。",
      "genres": [
        "合併"
      ],
      "tags": [
        "對準",
        "水果"
      ]
    },
    "ja": {
      "title": "オーピーチ・イット",
      "description": "OhPeach - これはダッシュ＆マージする果物が楽しめるゲームで、楽しい魅力的なゲームプレイを提供します。\n\nアイドルメカニズムを使用したり、パワーアップを使うと、ゲームがより魅力的になります。\n\nだから、果物をダッシュしてマージし続けましょう！",
      "instructions": "果物を合わせて高得点の果物を作成。果物からジュースを作り、スコアを上げる。",
      "genres": [
        "合体"
      ],
      "tags": [
        "標的",
        "果物"
      ]
    },
    "ko": {
      "title": "오피치-이트",
      "description": "OhPeach- 이는 다ッシュ&Merge 열초가 주는 재미있고 매력적인 게임입니다.\n\n아이드ل 메커니즘과 파워업을 사용하면 게임이 더 매력적이 됩니다.\n\n따라서 열초를 다ッシュ하고 합치세요!",
      "instructions": "과일을 서로 잡고 더 큰 과일을 만들어요. 과일을ジュース로 만들어 더 많은 점수를 받아요.",
      "genres": [
        "합성"
      ],
      "tags": [
        "瞄准",
        "과일"
      ]
    },
    "fr": {
      "title": "OhPeach-It",
      "description": "OhPeach - C'est un jeu sur le dash et la fusion de fruits qui vous offre du fun et un gameplay captivant.\n\nLe jeu devient encore plus captivant lorsque vous utilisez le mécanisme d'inactivité et les améliorations.\n\n Alors, continuez à faire dash et fusionner les fruits !",
      "instructions": "Faites glisser et frapper les fruits entre eux pour former des fruits plus élevés. Faites du jus avec les fruits et obtenez plus de points.",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "amour",
        "fruits"
      ]
    }
  }
};
